import { pgTable, uuid, text, integer, timestamp, jsonb, boolean, index } from "drizzle-orm/pg-core";

export const calendars = pgTable("calendars", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  name: text("name").notNull(),
  timezone: text("timezone").default("UTC").notNull(),
  ownerId: text("owner_id").notNull(),
  businessHours: jsonb("business_hours").default({}).notNull(),
  bufferMinutes: integer("buffer_minutes").default(0).notNull(),
  maxDailyBookings: integer("max_daily_bookings").default(50).notNull(),
  externalCalendarId: text("external_calendar_id"),
  externalProvider: text("external_provider"),  // google, microsoft
  syncEnabled: boolean("sync_enabled").default(false).notNull(),
  syncToken: text("sync_token"),  // Google/MS incremental sync token
  pushChannelId: text("push_channel_id"),  // Google push notification channel ID
  pushChannelExpiry: timestamp("push_channel_expiry", { withTimezone: true }),
  lastSyncAt: timestamp("last_sync_at", { withTimezone: true }),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).defaultNow().notNull(),
}, (table) => [
  index("idx_calendars_tenant").on(table.tenantId),
  index("idx_calendars_owner").on(table.tenantId, table.ownerId),
]);

export const BOOKING_STATUSES = ["confirmed", "cancelled", "rescheduled", "completed", "no_show"] as const;
export type BookingStatus = (typeof BOOKING_STATUSES)[number];

export const bookings = pgTable("bookings", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  calendarId: uuid("calendar_id").notNull(),
  personId: uuid("person_id").notNull(),
  title: text("title").notNull(),
  description: text("description"),
  startAt: timestamp("start_at", { withTimezone: true }).notNull(),
  endAt: timestamp("end_at", { withTimezone: true }).notNull(),
  timezone: text("timezone").default("UTC").notNull(),
  status: text("status").default("confirmed").notNull(),
  location: text("location"),
  locationUrl: text("location_url"),
  meetingUrl: text("meeting_url"),
  externalEventId: text("external_event_id"),
  reminderConfig: jsonb("reminder_config").default([]).notNull(),
  remindersSent: jsonb("reminders_sent").default([]).notNull(),
  cancelledAt: timestamp("cancelled_at", { withTimezone: true }),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).defaultNow().notNull(),
}, (table) => [
  index("idx_bookings_tenant").on(table.tenantId),
  index("idx_bookings_calendar").on(table.calendarId),
  index("idx_bookings_person").on(table.tenantId, table.personId),
  index("idx_bookings_time").on(table.tenantId, table.calendarId, table.startAt),
  index("idx_bookings_status").on(table.tenantId, table.status),
]);

export const bookingReminders = pgTable("booking_reminders", {
  id: uuid("id").primaryKey().defaultRandom(),
  bookingId: uuid("booking_id").notNull(),
  tenantId: uuid("tenant_id").notNull(),
  reminderType: text("reminder_type").notNull(),  // 24h, 1h, 15min, custom
  channel: text("channel").notNull(),  // email, sms, whatsapp
  scheduledAt: timestamp("scheduled_at", { withTimezone: true }).notNull(),
  sentAt: timestamp("sent_at", { withTimezone: true }),
  status: text("status").default("pending").notNull(),  // pending, sent, failed, cancelled
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
}, (table) => [
  index("idx_booking_reminders_booking").on(table.bookingId),
  index("idx_booking_reminders_scheduled").on(table.status, table.scheduledAt),
]);
